import 'styles/global.css';

import { render } from 'react-dom';
import Chrome from 'components/Chrome';

render(
	<Chrome />,
	document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./root.js
 **/